module.exports = __webpack_public_path__ + "static/examp1-014f7ee1fc30e4ba4ed7f485c9f69a99.gif";